import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { useSelector } from "react-redux";
import QuickSearchCompletionContainer from "../Containers/QuickSearchCompletion.Container";
import QuickSearchCompletionItem from "./QuickSearchCompletionItem";


const QuickSearchSuggestions = () => {
    const {query, completionSuggestions, nameSuggestions, searchInput } = useSelector((state) => state.quickSearch)
    return (
        <div className="quickSearch_suggestions.container">
            <QuickSearchCompletionContainer completionSuggestions={completionSuggestions} query={query} nameSuggestions={nameSuggestions} />
        </div>
    )
}

export default QuickSearchSuggestions;
